import { useEffect, useRef, useState } from "react"
import { POST } from "api/request"
import * as url from 'api/urls'
import FormPage from "./Form"
import Modal from "../Modal"
import Map from "./Map"

interface AddLocationModalProps {
  onClose: () => void
  onReload: () => void
}

export interface Form {
  coords?: base.Coords
  name: string
  birth: string
  death: string
  photo?: File
}

export interface Errors {
  name: string
  birth: string
  death: string
}

export type UpdateForm = (key: keyof Form, value: any) => void
type Page = 'form' | 'map' | 'summary'

const AddLocationModal: React.FC<AddLocationModalProps> = ({ onClose, onReload }) => {
  const [page, setPage] = useState<Page>('form')
  const [form, setForm] = useState<Form>({
    name: '',
    birth: '',
    death: ''
  })
  const [errors, setErrors] = useState<Errors>({
    name: '',
    birth: '',
    death: ''
  })

  const currentCoords = useRef(form.coords)
  currentCoords.current = form.coords

  const updateForm = (key: keyof Form, value: any) => {
    setForm(prev => ({ ...prev, [key]: value }))
  }

  const parseDate = (dateString: string | undefined): Date | null => {
    if (!dateString) return null
    const [year, month, day] = dateString.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  const validateFields = () => {
    const today = new Date()
    const birthDate = parseDate(form.birth)
    const deathDate = parseDate(form.death)

    const newErrors: Errors = {
      name: form.name.trim() ? '' : 'Imię i nazwisko są wymagane',
      birth: form.birth ? '' : 'Data urodzenia jest wymagana',
      death: form.death ? '' : 'Data śmierci jest wymagana'
    }

    if (deathDate && birthDate) {
      if (deathDate > today) {
        newErrors.death = 'Data śmierci nie moze byc późniejsza niz dzisiaj'
      }
      if (birthDate > today) {
        newErrors.birth = 'Data urodzenia nie moze byc późniejsza niz dzisiaj'
      }
      if (deathDate < birthDate) {
        newErrors.birth = 'Data urodzin nie moze byc późniejsza niz data śmierci'
        newErrors.death = 'Data śmierci nie moze byc wcześniejsza niz data urodzin'
      }
    }

    setErrors(newErrors)
    return !newErrors.name && !newErrors.birth && !newErrors.death
  }

  const handleSubmit = async () => {
    if (!validateFields()) {
      return
    }
    const formData = new FormData()
    formData.append('name', form.name)
    if (form.coords) {
      formData.append('gps[latitude]', form.coords.latitude.toString())
      formData.append('gps[longitude]', form.coords.longitude.toString())
    }
    formData.append('birth', form.birth)
    formData.append('death', form.death)
    if (form.photo) {
      formData.append('img', form.photo)
    }
    try {
      const response = await POST(url.boards, {
        form: formData
      })
      if (response.ok) {
        setPage('summary')
        onReload()
      } else {
        alert('Nie dodano - response false')
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getLocation = () => {
    const success = (position: GeolocationPosition) => {
      console.log(position)
      if (currentCoords.current &&
        currentCoords.current.latitude === position.coords.latitude &&
        currentCoords.current.longitude === position.coords.longitude) {
        console.log("Congratulations, you reached the target");
        navigator.geolocation.clearWatch(id)
      } else {
        console.log('update coords')
        setForm(prev => ({ ...prev, coords: position.coords }))
      }
    }

    const error = (err: GeolocationPositionError) => {
      console.error(`ERROR(${err.code}): ${err.message}`);
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    }

    const id = navigator.geolocation.watchPosition(success, error, options)
    return id
  }


  useEffect(() => {
    if (!navigator.geolocation) {
      alert("Twoja przeglądarka nie wspiera geolokalizacji.")
      return
    }

    const id = getLocation()
    return () => {
      navigator.geolocation.clearWatch(id)
    }
  }, [])

  return (
    <Modal
      icon='add-location'
      onClose={onClose}
      title='Dodaj pomnik'
      primaryButton={page === 'form' ? 'Dodaj lokalizacje' : page === 'map' ? 'Dodaj pomnik' : ''}
      primaryButtonAction={page === 'form' ? () => { validateFields() &&  setPage('map') } : page === 'map' ? handleSubmit : undefined}
      secondaryButton={page === 'form' ? 'Anuluj' : page === 'map' ? 'Cofnij' : 'Wróć do mapy'}
      secondaryButtonAction={page === 'map' ? () => { setPage('form') } : 'close'}>

      <div className="modal__addPost">
        {(() => {
          switch (page) {
            case "form": return (
              <FormPage
                form={form}
                errors={errors}
                updateForm={updateForm}
                validateFields={validateFields}
              />
            )

            case "map": return (
              <Map
                coords={form.coords}
                getLocation={getLocation}
                updatePosition={(coords) => {
                  setForm(prev => ({
                    ...prev,
                    coords
                  }))
                }}
              />
            )

            case "summary": return (
              <div className="info">
                <p>Pomnik został zapisany. Pinezka znajduje się na mapie.</p>
              </div>
            )
          }
        })()}
      </div>
    </Modal>
  )
}

export default AddLocationModal